<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Shift Assign
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-select
                :items="shiftInfoList"
                label="Shift Name"
                v-model="queryParams.shiftInfoId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.assignDate"
                  label="Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.assignDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="shiftAssignList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :pagination.sync="pagination"
            :must-sort="true"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr @click="props.expanded = !props.expanded">
                <td>{{ props.item.assignDateInMilliSeconds | format-ms-date }}</td>
                <td>{{ props.item.shiftInfoName}}</td>
                <td>{{ props.item.shiftAssignNo}}</td>
                <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date }}</td>
                <td>{{ props.item.updatedBy }}</td>
                <td>
                  <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.assignDetailList"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                    :must-sort="true"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.username }}</td>
                      <td class="text-xs">{{ subprops.item.counterName }}</td>
                      <td>
                        <v-icon v-if="subprops.item.status" medium color="green">check_circle</v-icon>
                        <v-icon v-else medium color="red">cancel</v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-text>
                  <v-data-table
                    :headers="subSPHeaders"
                    :items="props.item.assignSalePersonList"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                    :must-sort="true"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.username }}</td>
                      <td>
                        <v-icon v-if="subprops.item.status" medium color="green">check_circle</v-icon>
                        <v-icon v-else medium color="red">cancel</v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
            <!-- <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :headers="subHeaders"
                    :items="props.item.assignSalePersonList"
                    item-key="props.item.id"
                    hide-actions
                    class="elevation-10"
                    :must-sort="true"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td class="text-xs">{{ subprops.item.username }}</td>
                      <td class="text-xs">{{ subprops.item.counterName }}</td>
                      <td>
                        <v-icon v-if="subprops.item.status" medium color="green">check_circle</v-icon>
                        <v-icon v-else medium color="red">cancel</v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>-->
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { shiftAssignService } from "../../services/shift-assign-service";
import { commonService } from "../../services/common-service";
import { shiftInfoService } from "../../services/shift-info-service";
export default {
  name: "ShiftAssignList",

  components: {},
  data: () => ({
    showListLoading: false,
    breadcrumbs: [
      {
        text: "User Management",
        disabled: true
      },
      {
        text: "Shift Assigns",
        disabled: true
      }
    ],
    headers: [
      { text: "Assign Date", value: "assignDate" },
      { text: "Shift Name", value: "shiftInfoName" },
      { text: "ShiftAssign No", value: "shiftAssignNo" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Action", value: "name", sortable: false }
    ],
    subHeaders: [
      { text: "Cashier", value: "username" },
      { text: "Counter Name", value: "counterName" },
      { text: "Status", value: "status" }
    ],
    subSPHeaders: [
      { text: "Saleperson", value: "username" },
      { text: "Status", value: "status" }
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "assignDate",
      totalItems: 0
    },
    queryParams: {
      assignDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shiftInfoId: "",
      shopId: ""
    },
    shiftAssignList: [],
    shiftInfoList: [],
    totalRows: 0,
    sortedBy: "assignDate,desc"
  }),
  watch: {
    pagination: {
      handler() {
        this.getShiftAssignList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.assignDate) {
      this.queryParams.assignDate = this.$route.query.assignDate;
    }
    if (this.$route.query.shiftInfoId) {
      this.queryParams.shiftInfoId = this.$route.query.shiftInfoId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    let user = JSON.parse(localStorage.getItem("user"));
    this.queryParams.shopId = user.shopId;
    this.getShiftInfosByShopId(this.queryParams.shopId);
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "shift-assigns", query: this.queryParams });
      this.getShiftAssignList();
    },
    getShiftInfosByShopId(shopId) {
      shiftInfoService
        .getShiftInfosByShopId(shopId)
        .then(res => {
          this.shiftInfoList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getShiftAssignList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      shiftAssignService
        .getShiftAssignList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          this.shiftAssignList = res.data.assignList;
          this.totalRows = res.data.totalElements;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/shift-assign/new");
    },
    onEdit(shiftAssign) {
      // go to details page
      this.$router.push("/shift-assign/" + shiftAssign.id);
    }
  }
};
</script>

<style scoped>
</style>